import { ESettingsState } from 'components/Settings/Settings.types';

export enum ESharedRoutes {
  PLAYERS = 'players',
  LOCALIZATION = 'localization',
  SETTINGS = 'settings',
  PROFILE = 'profile',
  THEME = 'theme',
  TEMPLATES_STUDIO = 'templatesstudio',
  PRODUCTS = 'products',
  OFFERS_UI = 'offersui',
  OFFER_DESIGN = 'offerdesign',
  CHECKOUT_DESIGNS = 'checkoutdesigns',
  BADGES = 'badges',
  ASSETS = 'assets',
  BUNDLES = 'bundles',
  PROMOTIONS = 'promotions',
  POPUPS = 'popups',
  DAILY_BONUS = 'daily-bonus',
  ROLLING = 'rolling',
  BUY_ONE_GET_MANY = 'buy-one-get-many',
  CHECKOUT_LINKS = 'checkoutlinks',
  PROGRESS_BARS = 'progressbars',
  SUBSCRIPTIONS = 'subscriptions',
  PLANS = 'plans',
  PRICING = 'pricing',
  ORDERS = 'orders',
  REPORTS = 'reports',
  REWARD_CALENDAR = 'reward-calendar'
}

export enum ERouteContext {
  PROJECT = 'project',
  PORTAL = 'portal',
  PORTAL_LEVEL_STORE = 'store'
}

export type SettingsConfig = {
  defaultTab: ESettingsState;
  paths: ESettingsState[];
};

export type LevelSpecificRoute = {
  path: string;
  element: JSX.Element;
};
